import { devtools as _devtools } from "zustand/middleware";

// Wrap Zustand's devtools middleware so we can centralize defaults.
// We keep the exact signature of `devtools` so stores can still pass options.
export const createDevtools = (name: string): typeof _devtools => {
  return (initializer, options) =>
    _devtools(initializer, {
      enabled: true,
      name,
      ...options,
    });
};
